import { render, staticRenderFns } from "./MasterDataView.vue?vue&type=template&id=12ba6480&"
import script from "./MasterDataView.vue?vue&type=script&lang=js&"
export * from "./MasterDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports